/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/WinAnimators/FireworksWinAnimator',['pixi',
        'proton',
        'absolute/particleemitter',
        'CardUI/WinAnimators/BaseWinAnimator',
        'Arkadium/GameEngine/Scenes/Nodes/SceneNode',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Maths/Vector2',
        'Arkadium/GameEngine/Maths/Bezier2D',
        'Arkadium/GameEngine/Tween/Tween',
        'Arkadium/GameEngine/Core/EngineManagers',
        'absolute/audiomanager'
    ],
    function (PIXI, Proton, ParticleEmitter, BaseWinAnimator, SceneNode, SpriteNode, Vector2, Bezier2D, Tween, EngineManagers, AudioManager) {
        "use strict";

        var AnimationStateEnum =
        {
            None: 0,
            Fogging: 1,
            PilesGlow: 2,
            SpawnCards: 3,
            Done: 4
        };

        var FireworksWinAnimator = function (supplyView) {
            this.initFireworksWinAnimator(supplyView);
        };

        FireworksWinAnimator.prototype = Object.create(BaseWinAnimator.prototype);
        FireworksWinAnimator.prototype.constructor = FireworksWinAnimator;


        FireworksWinAnimator.prototype.initFireworksWinAnimator = function (supplyView) {
            BaseWinAnimator.call(this, supplyView);

            this._foggingBackground = null;
            this._pileView = null; /* PileView */
            this._glow = null; /* SpriteNode */
            this._animationState = AnimationStateEnum.None; /* AnimationStateEnum */

            this._numberOfCardsFallen = 0; /* int */
            this._numberOfCardsFinished = 0; /* int */
            this._totalNumberOfCards = 0; /* int */
            this._cardSpawnDelay = 0.0; /* float */
            this._glowStarted = false; /* bool */
            this._pilesCount = 0; /* int */
        };

        FireworksWinAnimator.prototype.ShouldStartDuringCardMovement = function () /* bool */
        {
            return false;
        };

        FireworksWinAnimator.prototype.BeginAnimation = function (/* Action */ endAnimationCallback, /* Card */ lastCardDropped, /* Pile */ lastPileDroppedOnto, /* bool */ dragging)
        {
            this._numberOfCardsFallen = 0;
            this._numberOfCardsFinished = 0;
            this._totalNumberOfCards = this.SupplyView.CardSupply.GetCardList().length;
            this._cardSpawnDelay = 0.5;

            this._animationState = AnimationStateEnum.Fogging;

            AudioManager.playSound('winFireworks');

            BaseWinAnimator.prototype.BeginAnimation.call(this, endAnimationCallback, lastCardDropped, lastPileDroppedOnto, dragging);
        };

        FireworksWinAnimator.prototype.OnSizeChanged = function (/* object */ sender, /* WindowSizeChangedEventArgs */ e)
        {
            this.FinishEndingAnimation();
        };

        FireworksWinAnimator.prototype.UpdateEndingAnimation = function (/* object */ o, /* EventArgs */  time)
        {
            if (this._hasUserClicked)
            {
                this.FinishEndingAnimation();
                return;
            }


            if (this._numberOfCardsFinished >= this._totalNumberOfCards)
            {
                this._animationState = AnimationStateEnum.Done;
            }

            if (this._animationState == AnimationStateEnum.Fogging)
            {
                this.SetFoggingBackground();
                if (this._foggingBackground.alpha < 0.6) {
                    this._foggingBackground.alpha += 0.01;
                }
                else  {
                    this._animationState = AnimationStateEnum.PilesGlow;
                }
            }

            if (this._animationState == AnimationStateEnum.PilesGlow)
            {
                if (!this._glowStarted)
                {
                    this.StartGlow();
                }

            }

            if (this._animationState == AnimationStateEnum.SpawnCards)
            {
                this._animationState = AnimationStateEnum.None;
                var /* CardView */ card;
                if (this.SupplyView.CardSupply.GetCardList().length > 52)
                {
                    var /* Pile */ pile = this.SupplyView.CardSupply.GetPile("Foundation" + (this._numberOfCardsFallen % 8));
                    card = this.SupplyView.GetCardView(pile.NthFromTop(Math.floor(1 + this._numberOfCardsFallen / 8)));
                }
                else
                {
                    var /* Pile */ pile = this.SupplyView.CardSupply.GetPile("Foundation" + (this._numberOfCardsFallen % 4));
                    card = this.SupplyView.GetCardView(pile.NthFromTop(Math.floor(1 + this._numberOfCardsFallen / 4)));
                }
                var spinCardNode = new SpinCardNode(this, card);
                this.AnimationContainer.AddChild(spinCardNode);
                spinCardNode.TriggerSpawn();
                card.Animating = true;
                //card.Visible = false;
                this._numberOfCardsFallen++;
                switch (this._numberOfCardsFallen)
                {
                    case 10:
                        this._cardSpawnDelay -= 0.1;
                        break;
                    case 25:
                        this._cardSpawnDelay -= 0.1;
                        break;
                }

                // Wait the prescribed amount of time before transitioning back into SpawnCards state to spawn the next card
                if (this._numberOfCardsFallen < this._totalNumberOfCards)
                {
                    Tween.Start(this.SupplyView).Wait(this._cardSpawnDelay).Then().Call(function () { this._animationState = AnimationStateEnum.SpawnCards; }.bind(this));
                }
            }
            if (this._animationState == AnimationStateEnum.Done)
            {
                this._animationState = AnimationStateEnum.None;
                Tween.Start(this.SupplyView.GameContainer).Wait(0.5).Then().Call(this.FinishEndingAnimation.bind(this));
            }
        };

        FireworksWinAnimator.prototype.SetFoggingBackground = function()
        {
            if (this._foggingBackground == null)
            {
                this._foggingBackground = new PIXI.Graphics();
                this._foggingBackground.beginFill(0, 1);
                this._foggingBackground.drawRect(-0x2710, -0x2710, 0x4E20, 0x4E20);
                this._foggingBackground.endFill();
                this._foggingBackground.alpha = 0;
                this._background.addChild(this._foggingBackground);
            }
        };


        FireworksWinAnimator.prototype.StartGlow = function ()
        {
            this._pilesCount = this.SupplyView.CardSupply.GetCardList().length > 52 ? 8 : 4;

            for (var i = 0; i < this._pilesCount; i++)
            {
                this._pileView = this.SupplyView.GetPileView("Foundation0");
                var scaleFactor = (this.SupplyView.GetCardView(this._pileView.Pile.NthFromTop(1)).ScaleX * 0.8);
                this._glow = new SpriteNode("fireworks-card-glow.png");
                this._glow.TextureAlphaEnabled = true;
                this._glow.Scale = new Vector2(scaleFactor, scaleFactor);
                this._glow.Visible = true;
                this._glow.Layer = 6;
                this._glow.Alpha = 0.0;


                var props = new Tween.TweenProperties();
                props.NumLoops = Tween.InfiniteLoops;

                this._pileView = this.SupplyView.GetPileView("Foundation" + i);
                Tween.Start(this._glow, props).FadeTo(0.5, 1.2).Then().FadeTo(0.1, 1.2);
                this._pileView.AddChildAt(this._glow, 0);
            }
            Tween.Start(this._pileView).Wait(1).Then().Call(function () { this._animationState = AnimationStateEnum.SpawnCards;}.bind(this));
            this._glowStarted = true;
        };

        FireworksWinAnimator.prototype.FinishEndingAnimation = function ()
        {
            if (!this._hasAnimationStarted) return;

            AudioManager.stopSound('winFireworks');

            for (var i = 0; i < this._pilesCount; i++)
            {
                this._pileView = this.SupplyView.GetPileView("Foundation" + i);
                this._pileView.removeChildAt(0);
            }

            BaseWinAnimator.prototype.FinishEndingAnimation.call(this);
        };

        FireworksWinAnimator.prototype.IsAnimationRunning = function () /* bool */
        {
            return this._hasAnimationStarted && !this._hasUserClicked &&  this._numberOfCardsFinished < this._totalNumberOfCards;
        };

        FireworksWinAnimator.prototype.DidStartAnimation = function () /* bool */
        {
            return this._hasAnimationStarted;
        };

        FireworksWinAnimator.prototype.ShouldShowEndingPopup = function () /* bool */
        {
            return this._hasAnimationStarted && (this._hasUserClicked || this._numberOfCardsFinished >= this._totalNumberOfCards);
        };

        FireworksWinAnimator.prototype.StopAnimationPointEvent = function (/* PointEvent */ pointEvent)
        {
            this.DoClickEnding();
        };

        FireworksWinAnimator.prototype.StopAnimationKeyEvent = function (/* KeyboardEvent */ keyboardEvent)
        {
            /*
            TODO
            if (keyboardEvent.Key == VirtualKey.Enter && keyboardEvent.Pressed)
            {
                DoClickEnding();
            }
            */
        };

        FireworksWinAnimator.prototype.DoClickEnding = function ()
        {
            if (this._animationState == AnimationStateEnum.None)
            {
                this._hasUserClicked = true;
            }
        };

        FireworksWinAnimator.prototype.IncrementNumberCardsFinished = function ()
        {
            this._numberOfCardsFinished++;
        };


        var SpinCardNode = function (animator, cardView) {
            this.initSpinCardNode(animator, cardView);
        };

        SpinCardNode.contstuctor = SpinCardNode;
        SpinCardNode.prototype = Object.create(SpriteNode.prototype);

        SpinCardNode.prototype.initSpinCardNode = function (animator, cardView) {
            SpriteNode.call(this);

            this._cardAnimator = animator;
            this._cardView = cardView;

            this.paused = false;
            this._cardNode = null;
            this._glowNode = null;

            this.fwtextures = [
            PIXI.Texture.fromFrame('particle_glow_blue.png'), 
            PIXI.Texture.fromFrame('particle_glow_green.png'), 
            PIXI.Texture.fromFrame('particle_glow_orange.png'),
            PIXI.Texture.fromFrame('particle_glow_pink.png'),
            PIXI.Texture.fromFrame('particle_glow_purple.png'),
            PIXI.Texture.fromFrame('particle_glow_yellow.png')];
        };


        SpinCardNode.prototype.PauseAnimation = function ()
        {
            this._paused = true;
        };

        SpinCardNode.prototype.UpdateInternal = function (/* GameTime */ time)
        {
            if (!this._paused) { }

            if (this._cardNode != null && this.Visible) { }

            //this._glowNode.Alpha += time.ElapsedGameTime.Milliseconds * 0.001;
            SpriteNode.prototype.UpdateInternal.call(this, time);
        };        

        SpinCardNode.prototype.TriggerSpawn = function ()
        {
            this.position = this.toLocal(this._cardView.toGlobal(this._cardView.position));
            this.glow = new SpriteNode("fireworks-card-glow.png");
            this.glow.scale.x = this.glow.scale.y = this._cardView.width / (this.glow.width * 0.7);
            this.glow.alpha = 0;

            this.addChild(this._cardView);
            this.addChild(this.glow);

            var xend = this.position.x + EngineManagers.Display.Width / 8 * this._cardAnimator.AnimationSide + Math.floor(Math.random() * EngineManagers.Display.Width / 4 * this._cardAnimator.AnimationSide);
            var yend = this.position.y + EngineManagers.Display.Height / 4 * (-this._cardAnimator.AnimationSide) + (Math.floor(Math.random() * EngineManagers.Display.Height / 2 * (-this._cardAnimator.AnimationSide)));

            var xc = [this.position.x - xend / 4, xend];
            var yc = [(yend / 4), yend];

            var self = this;
            var fallTween = new TWEEN.Tween({x: this.position.x, y: this.position.y, rotation: this.rotation, alpha: 0})
                .easing(TWEEN.Easing.Linear.None)
                .interpolation(TWEEN.Interpolation.Bezier)
                .to({x: xc, y: yc, rotation: -2 * Math.PI, alpha: 1}, 1000)
                .onStart(function(){

                })
                .onUpdate(function(){
                    self.position.x = this.x;
                    self.position.y = this.y;
                    self.rotation = this.rotation;
                    self.glow.alpha = this.alpha;
                })
                .onComplete(function(){

                    self._cardView.visible = false;
                    self.glow.visible = false;

                    var texture = [self.fwtextures[Math.floor(Math.random() * self.fwtextures.length)]],
                        emitter = new ParticleEmitter(EngineManagers.UI, texture, function (e) { 
                            var proton = new Proton();                           
                            e.rate = new Proton.Rate(new Proton.Span(150, 200), 1);
                            e.addInitialize(new Proton.Mass(1));
                            e.addInitialize(new Proton.Radius(4, 8));
                            e.addInitialize(new Proton.Life(1, 1.5));
                            e.addInitialize(new Proton.V([.1, .2, .3, .4, .5, .6, .7, .8, .9, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, 2.8, 2.9, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9], new Proton.Span(0, 360), 'polar'));
                            e.addInitialize(new Proton.ImageTarget(texture, 32));
                            e.addBehaviour(new Proton.Alpha(1, [.5, 0]));
                            e.addBehaviour(new Proton.Scale([1, 2], .1));
                            e.addBehaviour(new Proton.Gravity(1));
                            var color = Proton.MathUtils.randomColor();
                            e.addBehaviour(new Proton.Color(color));
                            e.p.x = 0;
                            e.p.y = 0;
                            e.emit('once', true);
                            proton.addEmitter(e);
                            //AudioManager.playSound('firework' + (Math.round(Math.random() * 3) + 1).toString());
                        });

                    AudioManager.playSound('firework' + (Math.round(Math.random() * 3) + 1).toString());
                  
                    self.addChild(emitter);

                    self._cardAnimator.IncrementNumberCardsFinished();
                });

            fallTween.start();
        };

        return FireworksWinAnimator;
});

